import { render, staticRenderFns } from "./UrlBuilder.vue?vue&type=template&id=4884f6a6&"
import script from "./UrlBuilder.vue?vue&type=script&lang=js&"
export * from "./UrlBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports